import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'

/**
 * Page body wrapper. The navigation, footer and page crossfade live in
 * _app.tsx so they persist between pages.
 */
export const Layout: FC<LayoutProps> = ({ children, className }): ReactNode => {
    return (
        <main id='main' className={cn('relative flex-1', className)}>
            {children}
        </main>
    )
}
